/**
 * A stamp signifying that an object is a `LazyReference`.
 * @ignore @internal
 */
export const LAZY_REFERENCE = Symbol('LAZY_REFERENCE');
/**
 * A stamp signifying that an object is a `InjectedFactory`.
 * @ignore @internal
 */
export const INJECTED_FACTORY = Symbol('INJECTED_FACTORY');
//# sourceMappingURL=type-stamps.const.js.map